window.dn = window.dn || {};

/** All methods related to topics */
(function (topic, $, undefined)
{
    topic.Urls = {
        Lookup: "/api/v1/topic",
        Query:  "/api/v1/topic/query",
        Upsert: "/api/v1/topic"
    };

    /** 
     * Used in response to the Update(), Subscribe(), and Invite() methods to reflect what happened. 
     *  
     * Keep this in sync with C# Topic.TopicAction enum.
    */
    topic.TopicAction = {
        None:       0,
        Completed:  1,
        Created:    2,
        Failed:     3,
        Updated:    4,
        Queued:     5
    };

    /**
     * The DOM identifier used for the modal dialogs related to creating a group, and prefix for related elements.
     */
    topic.CreateTopicId = "dn-create-topic";

    /**
     * The DOM identifier used for the modal dialogs related to external subscriptions, and prefix for related elements.
     */
    topic.SubscribeExternallyId = "dn-subscribe-externally";

    /**
     * Add a manager to a group.
     * 
     * @param {string}  opt.topicIdOrKey     - The TopicId or TopicKey of the group being modified.
     * @param {string}  opt.userKey          - The UserKey of the user to make a manager of this group.
     * @param {func}    opt.onSuccess        - If we're able to successfully add the manager, we'll call this with the response.
     * @param {func}    opt.onError          - If we can't invite/approve the user for some reason, we'll call this with the jquery error info
     */
    topic.AddManager = function(opt) {

        $.postJSON("/api/v1/topic/" + opt.topicIdOrKey + "/manager", {
            UserKey: opt.userKey
        })
        .done(function (response) {

            dn.constants.Topics[response.Topic.TopicId] = response.Topic; // "cache" it for later

            if (opt.onSuccess)
            {
                opt.onSuccess(response);
            }
        })
        .fail(function (xhr, textStatus, errorThrown) {

            if (opt.onError)
            {
                opt.onError(xhr, textStatus, errorThrown);
            }
        });
    };

    /**
     * Approve a user's subscription request to join a group. (Although this hit's an endpoint that
     * can invite a user to join a group, it is recommended to use the dn.user.Invite() method for that
     * purpose, as it can handle multiple users, multiple groups, prompting as needed.)
     * 
     * @param {string}  opt.topicIdOrKey     - The TopicId or TopicKey to invite the user to. If not given, we'll present a popup to prompt them to choose.
     * @param {string}  opt.userKey          - The UserKey of the user to invite/approve.
     * @param {string}  opt.message          - If set, will be sent to the user being invited/approved.
     * @param {func}    opt.onSuccess        - If we're able to successfully invite (or queue invitation), we'll call this with the response.
     * @param {func}    opt.onError          - If we can't invite/approve the user for some reason, we'll call this with the jquery error info
     */
    topic.ApproveSubscription = function(opt) {

        if (!opt.topicIdOrKey || !opt.userKey)
        {
            dn.ShowModal({
                title: 'Error',
                body: 'You must supply the group and user information to approve a subscription request.'
            });
        }
        else
        {
            dn.Spin(true);
            $.postJSON
            (
                "/api/v1/topic/" + opt.topicIdOrKey + "/invitation", 
                {
                    UserKey: opt.userKey,
                    Message: opt.message
                }
            )
            .done(function (results) 
            {
                dn.Spin(false);

                $.each(results, function(index, result) {
                    dn.constants.Topics[result.Topic.TopicId] = result.Topic; // "cache" it for later
                });

                if (opt.onSuccess)
                {
                    opt.onSuccess(results);
                }
            })
            .fail(function (xhr, textStatus, errorThrown) 
            {
                dn.Spin(false);

                if (opt.onError)
                {
                    opt.onError(xhr, textStatus, errorThrown);
                }
            });
        }
    };

    /**
     * Show the "Create/Update User Group" modal popup.
     * 
     * @param {string} topicIdOrKey - The TopicKey or TopicId of the topic or group to update, or null if we're creating a new group.
     * @param {func} onSuccess      - Callback run when the topic or group has been created or updated, passing back the newly updated/created topic. If none given, we'll show a confirmation dialog.
     * @param {func} onClose        - Callback that will be run if the modal is closed.
     */
    topic.CreateOrUpdate = function(topicIdOrKey, type, onSuccess, onClose) {

        var id = '#' + topic.CreateTopicId;

        topic.Lookup({topicIdOrKey: topicIdOrKey, showAjaxSpinner: true, 

            onSuccess: function(data) {

                if (!dn.user.IsLoggedIn)
                {
                    // Anon users get asked to login first
                    dn.PromptToLogin('create a user group');
                    return;
                }
                else if (!dn.user.CanManage)
                {
                    dn.PromptToUpgrade('CanManage', {TopicId: (data.TopicId || 0)});
                    return;
                }

                var action = 'Create';
                var intro = 'Create a user group to form your own community within ' + dn.constants.CommunityName + '.';

                if (data.TopicId)
                {
                    action = 'Update';
                    intro = '';
                }

                // remove any existing topic modals if open
                $(id).modal('hide');
                $(id).modal('dispose');
                $(id).remove(); 

                var currentMinimumExperience = (data.MinimumExperience > -1 ? data.MinimumExperience : dn.constants.TopicMinimumExperience);

                $("body").append($('<div class="modal" tabindex="-1" role="dialog" style="display: none" id="' + topic.CreateTopicId + '" data-minimum-experience="' + currentMinimumExperience + '">\
                    <div class="modal-dialog modal-lg" role="document">\
                        <div class="modal-content">\
                            <div class="modal-header">\
                                <h5 class="modal-title"><b>' + action + ' User Group</b></h5>\
                                <button type="button" class="close ' + topic.CreateTopicId + '-close" data-dismiss="modal" aria-label="Close">\
                                <span aria-hidden="true">&times;</span>\
                                </button>\
                            </div>\
                            <div class="modal-body">\
                                <p>' + intro + ' <a href="/help#user-groups" target="' + dn.constants.LinkTargetNewWindow + '">More about user groups.</a></p>\
                                <div class="alert alert-danger" style="display: none" id="' + topic.CreateTopicId + '-error" role="alert"></div>\
                                <label for="' + topic.CreateTopicId + '-name" class="dn-form-label mt-1 mb-0">Name</label> <span class="opacity-50 text-small">(' + dn.constants.TopicMaxLengthName + ' chars max)</span>\
                                <div class="input-group mb-2">\
                                    <input name="nameNotSearch" type="text" id="' + topic.CreateTopicId + '-name" maxlength="' + dn.constants.TopicMaxLengthName + '" value="' + (data.Name || '') + '" class="dn-topic-name form-control col-6" aria-label="Name of your group" autocomplete="off"> \
                                </div>\
                                <label for="' + topic.CreateTopicId + '-nameshort" class="dn-form-label mt-1 mb-0">Short Name</label> <span class="opacity-50 text-small">(' + dn.constants.TopicMaxLengthNameShort + ' chars max)</span>\
                                <div class="input-group mb-2">\
                                    <input name="nameShortNotSearch" type="text" id="' + topic.CreateTopicId + '-nameshort" maxlength="' + dn.constants.TopicMaxLengthNameShort + '" value="' + (data.NameShort || '') + '" class="dn-topic-nameshort form-control col-6" aria-label="Abbreviated name" autocomplete="off"> \
                                </div>\
                                <label for="' + topic.CreateTopicId + '-topickeyurl" class="dn-form-label mt-1 mb-0">User Group Address</label> <span class="opacity-50 text-small">(' + dn.constants.TopicMaxLengthTopicKeyUrl + ' chars max)</span>\
                                <div class="input-group mb-0" id="' + topic.CreateTopicId + '-topickeyurl-wrapper">\
                                    <div class="input-group-prepend">\
                                        <span class="input-group-text pl-1 text-muted dn-prepend-topickeyurl"><span>' + dn.constants.BaseHref + '/g/</span></span>\
                                    </div>\
                                    <input name="topicKeyUrlNotSearch" type="text" id="' + topic.CreateTopicId + '-topickeyurl" maxlength="' + dn.constants.TopicMaxLengthTopicKeyUrl + '" value="' + (data.TopicKeyUrl || '') + '" class="dn-topic-topickeyurl dn-no-outline form-control col-auto pl-0" aria-label="Web address" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"> \
                                </div>\
                                <div class="invalid-feedback mx-1 mx-sm-0" id="' + topic.CreateTopicId + '-topickeyurl-error"></div>\
                                <label for="' + topic.CreateTopicId + '-description" class="dn-form-label mt-3 mb-0">Description</label>\
                                <textarea class="form-control mb-0" id="' + topic.CreateTopicId + '-description" class="' + topic.CreateTopicId + '-description" rows="3" placeholder="Describe your user group in a few sentences.">' + (data.Description || '') + '</textarea>\
                                <label for="' + topic.CreateTopicId + '-minimum-experience" class="dn-form-label mt-3 mb-0">Minimum Experience Required</label>\
                                <div class="mt-0 mb-2">You control the minimum experience required for a member to start new discussions in your group. <a data-toggle="collapse" href="#' + topic.CreateTopicId + '-minimum-experience-more-info" aria-expanded="false" onclick="$(this).hide()">More info.</a> \
                                    <span id="' + topic.CreateTopicId + '-minimum-experience-more-info" class="collapse">If a user has fewer years of experience than what you select, they will not be able to start new discussions, but they <i>will</i> be able to reply, vote, and tag.For example, if you want to allow automotive students to participate in your group, you may want to \
                                    lower your minimum to 0 years. We currently recommend a minimum of ' + dn.constants.TopicMinimumExperience + ' years of experience for most groups, which is what we use \
                                    for our discussion topics.</span></div>\
                                <div id="' + topic.CreateTopicId + '-minimum-experience" class="' + topic.CreateTopicId + '-minimum-experience dropdown dn-modal-dropdown">\
                                    <button id="' + topic.CreateTopicId + '-minimum-experience-button" class="btn btn-lg dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Minimum Experience</button>\
                                    <div class="dropdown-menu position-absolute" id="' + topic.CreateTopicId + '-minimum-experience-choices" aria-labelledby="' + topic.CreateTopicId + '-minimum-experience">\
                                        <button class="dropdown-item" data-minimum-experience="0">0 yrs (e.g. Students)</button>\
                                        <button class="dropdown-item" data-minimum-experience="1">1 yrs</button>\
                                        <button class="dropdown-item" data-minimum-experience="2">2 yrs</button>\
                                        <button class="dropdown-item" data-minimum-experience="3">3 yrs</button>\
                                        <button class="dropdown-item" data-minimum-experience="4">4 yrs</button>\
                                        <button class="dropdown-item" data-minimum-experience="5">5 yrs</button>\
                                        <button class="dropdown-item" data-minimum-experience="10">10 yrs</button>\
                                        <button class="dropdown-item" data-minimum-experience="10">15 yrs</button>\
                                        <button class="dropdown-item" data-minimum-experience="20">20 yrs</button>\
                                        <button class="dropdown-item" data-minimum-experience="30">30 yrs</button>\
                                        <button class="dropdown-item" data-minimum-experience="40">40 yrs</button>\
                                    </div>\
                                </div>\
                                <label for="' + topic.CreateTopicId + '-type" class="dn-form-label mt-3 mb-0">Type</label>\
                                <div class="mt-0 mb-2">You cannot make a group <i>more</i> visible once messages have been posted to it.</div>\
                                <div id="' + topic.CreateTopicId + '-type" class="' + topic.CreateTopicId + '-type dropdown dn-modal-dropdown">\
                                    <button id="' + topic.CreateTopicId + '-type-button" class="btn btn-lg dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Choose Type</button>\
                                    <div class="dropdown-menu position-absolute" id="' + topic.CreateTopicId + '-type-choices" aria-labelledby="' + topic.CreateTopicId + '-type">\
                                        <button class="dropdown-item" data-type="' + dn.constants.TopicType.OpenGroup    + '"><i class="d-xs-none ' + dn.topic.GetIconClass(dn.constants.TopicType.OpenGroup) + '"></i> <b>Open</b>: anyone can subscribe</button>\
                                        <button class="dropdown-item" data-type="' + dn.constants.TopicType.ClosedGroup  + '"><i class="d-xs-none ' + dn.topic.GetIconClass(dn.constants.TopicType.ClosedGroup) + '"></i> <b>Closed</b>: subscribers require approval</button>\
                                        <button class="dropdown-item" data-type="' + dn.constants.TopicType.PrivateGroup + '"><i class="d-xs-none ' + dn.topic.GetIconClass(dn.constants.TopicType.PrivateGroup) + '"></i> <b>Private</b>: only visible to subscribers</button>\
                                    </div>\
                                </div>\
                                <div class="dn-group-description mt-3 dn-group-' + dn.constants.TopicType.OpenGroup + '" style="display: none"><b>Open Group</b>: Similar to discussion topics, anyone can instantly subscribe and post to open groups, no manager approval needed. Managers <b>cannot</b> remove people from an open user group.</div>\
                                <div class="dn-group-description mt-3 dn-group-' + dn.constants.TopicType.ClosedGroup + ' style="display: none"><b>Closed Group</b>: Subscription requests will require the approval of a group manager. Managers of closed groups can remove/ban subscribers.<br/><br/>The opening message of any discussion posted to a closed group is visible to everyone, but anonymized, meaning no replies or participants are visible, and limited author details are shown.<br/><br/>Only approved subscribers can post to a closed group and see the other subscribers.</div>\
                                <div class="dn-group-description mt-3 dn-group-' + dn.constants.TopicType.PrivateGroup + ' style="display: none"><b>Private Group</b>: Similar to closed groups, but the group, its messages, and its subscribers are only visible to people subscribed to the group. The only way new members can see or subscribe to the group is if they are invited by a manager.<br/><br/><b>NOTE: You must <a href="/contact">contact us</a> if you\'re interested in having a private group.</b></div>\
                                <p id="closing-modal"></p>\
                            </div>\
                            <div class="modal-footer">\
                                <button type="button" class="btn btn-primary" id="' + topic.CreateTopicId + '-button">' + action + ' User Group</button>\
                            </div>\
                        </div>\
                    </div>\
                </div>'));

                // stop any spinners before showing our new one
                dn.Spin(false);

                // remember the modals that were already open before us, so we can show them when done. 
                var openModals = $('.modal.show');
                openModals.modal('hide');

                // For some reason this event only works if I wire it up before .modal() is called.
                $(id).on
                (
                    'shown.bs.modal', 
                    function () 
                    {
                        if (!data.TopicId)
                        {
                            window.setTimeout
                            (
                                function()
                                { 
                                    $(id + '-name').focus(); 
                                }, 
                                0
                            );
                        }
                    }
                );

                $(id).modal();

                var nameShort = $(id + '-nameshort').val();
                var topicKeyUrl = $(id + '-topickeyurl').val();

                // Handle clicks on the "Minimum Experience Required" button
                $(id + '-minimum-experience button').click(function(event) {
                    var minimumExperience = parseInt($(this).data('minimum-experience'));
                    $(id).data('minimum-experience', minimumExperience);
                    $(id + '-minimum-experience-button').html($(this).html());
                });

                // Handle clicks on the user group type dropdown
                $(id + '-type-choices button').click(function(event) {
                    var topicType = $(this).data('type');
                    $(id).data('type', topicType);
                    $(id + '-type-button').html($(this).html());
                    $('.dn-group-description').hide();
                    $('.dn-group-' + topicType).show();
                });

                // Add "(Recommended)" to our default minimum experience level.
                $(id + '-minimum-experience-choices button[data-minimum-experience=' + dn.constants.TopicMinimumExperience + ']').html($(id + '-minimum-experience-choices button[data-minimum-experience=' + dn.constants.TopicMinimumExperience + ']').html() + ' (Recommended)');

                // select the current choice for MinimumExperience
                $(id + '-minimum-experience-choices button[data-minimum-experience=' + currentMinimumExperience + ']').click();

                // select the current type, or if new, the `type` passed in, if any, otherwise Open
                $(id + '-type-choices button[data-type=' + (data.Type || type || 1) + ']').click();

                $('.dn-prepend-topickeyurl').click(function(event) {
                    $(id + '-topickeyurl').focus();
                });

                $(id + '-topickeyurl').focus(function(event) {
                    $(id + '-topickeyurl-wrapper').addClass('focus');
                });

                $(id + '-topickeyurl').blur(function(event) {
                    $(id + '-topickeyurl-wrapper').removeClass('focus');
                });

                // Handle text changes in the Name field
                $(id + '-name').on('blur change keydown', dn.Debounce(function()
                {
                    var n = $(this).val();

                    if (nameShort === n || !nameShort)
                    {
                        // they haven't yet set short name, so fill in with what they're typing here
                        if (n.lengthInTextElements() > dn.constants.TopicMaxLengthNameShort)
                        {
                            $(id + '-nameshort').val(n.substring(0, dn.constants.TopicMaxLengthNameShort));
                        }
                        else
                        {
                            $(id + '-nameshort').val(n);
                        }
                    }
                }, 200));

                // Handle text changes in the NameShort field
                $(id + '-nameshort').on('blur change keydown', dn.Debounce(function()
                {
                    var ns = $(this).val();

                    if (!topicKeyUrl)
                    {
                        // they haven't yet set topic key url, so set it based on this
                        $(id + '-topickeyurl').val(dn.text.NormalizeForUrl(ns, dn.constants.TopicMaxLengthTopicKeyUrl));
                    }

                    nameShort = ns;
                }, 200));

                // Handle text changes in the TopicKeyUrl field
                $(id + '-topickeyurl').on('blur change keydown', dn.Debounce(function()
                {
                    topicKeyUrl = dn.text.NormalizeForUrl($(this).val(), dn.constants.TopicMaxLengthTopicKeyUrl);
                    $(this).val(topicKeyUrl);

                    if (data.TopicKeyUrl && data.TopicKeyUrl != topicKeyUrl)
                    {
                        // warn them that they are changing the URL of their group
                        $(id + '-topickeyurl-error').html('<b>WARNING:</b> You\'re changing your group address, which could break links. Previous address: <b>' + dn.constants.BaseHref + data.LinkRelative + '</b>.').show();
                    }
                    else
                    {
                        $(id + '-topickeyurl-error').html('').hide();
                    }
                }, 200));

                // Create/Update button clicked
                $(id + '-button').click(function(event) {

                    $(event.target).attr('disabled', true);
                    dn.Spin(true);

                    $.postJSON(topic.Urls.Upsert, {
                        MinimumExperience: parseInt($(id).data('minimum-experience')),
                        ColorPrimary: data.ColorPrimary,            // TODO: Let the user set this
                        ColorText: data.ColorText,                  // TODO: Let the user set this
                        Description: $(id + '-description').val(),
                        IsEnabled: (data.TopicId ? data.IsEnabled : true),  // TODO: Let the user control this. For now, leave it the way it is unless it's new, then default to enabled
                        Name: $(id + '-name').val(),
                        NameShort: $(id + '-nameshort').val(),
                        OwnerUserKey: dn.user.UserKey,              // TODO: Let the owner set a new owner
                        TopicId: parseInt(data.TopicId || 0),
                        TopicKeyUrl: $(id + '-topickeyurl').val(),
                        Type: parseInt($(id).data('type') || 1),
                    })
                    .done(function (response) 
                    {
                        dn.constants.Topics[response.TopicId] = response; // "cache" it for later

                        dn.Spin(false);
                        $(id).modal('hide');
                        $(event.target).attr('disabled', false);

                        if (onSuccess)
                        {
                            // They want to do something when we're done, so close our modal and do it.
                            onSuccess(response);
                        }
                        else
                        {
                            // They didn't tell us what to do, so we'll just show a confirmation.
                            var detailsLink = response.LinkDetailsRelative;
                            dn.ShowModal({
                                title: 'User Group ' + action + 'd',
                                body: '<a href="' + response.LinkRelative + '">' + response.Name + '</a> has been ' + action.toLowerCase() + 'd.',
                                buttonText: 'View Group Details',
                                onButtonClick: function() {
                                    window.top.location.href = detailsLink;
                                }
                            });
                        }
                    })
                    .fail(function (xhr, textStatus, errorThrown) {

                        // Stop the progress spinner
                        dn.Spin(false);
                        $(event.target).attr('disabled', false);

                        if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) {
                            $(id + '-error').html(dn.FormatApiError(xhr.responseJSON)).show();
                            // $(id + '-amount').addClass("is-invalid");
                        }
                    });
                });

                // Close button clicked
                $('.' + topic.CreateTopicId + '-close').click(function(event) {
                    if (onClose)
                    {
                        onClose();
                    }
                });

                $(id).modal('show');
            }, 

            // On topic lookup failure
            onError: function() {
                dn.ShowModal({ title: "Couldn't Locate User Group", body: 'We were unable to locate this user group: <samp>' + topicIdOrKey + '</samp>' });
            }
        });
    };

    /**
     * Return the icon class name representing this topic/group type. Most type icons are
     * straight-forward, though the open group class name can vary based on the user's region,
     * since it is a globe icon, and we reflect the user's region in the view of the globe.
     */
    topic.GetIconClass = function(type)
    {
        if (type === dn.constants.TopicType.OpenGroup)
        {
            return dn.constants.TopicIconClasses[type].replace("{0}", dn.user.Region);
        }
        else
        {
            return dn.constants.TopicIconClasses[type];
        }
    }

    /**
     * This gets wired up to checkboxes to handle group subscriptions.
     * The element should contain data-topic-id="" or data-topic-key=""
     * 
     * @param {event}   event   - The target of the event. Probably a checkbox.
     * @param {func}    onSuccess - Callback run when the subscription is successful. (Queuing of a subscription request to a closed group is considered a success, fyi.)
     * @param {func}    onError - Callback run when the subscription fails.
     */
    topic.HandleSubscribeClick = function(event, onSuccess, onError)
    {
        event.stopPropagation(); // don't let this event bubble up

        if (!dn.user.IsLoggedIn)
        {
            // Anon users get asked to login first
            dn.PromptToLogin('subscribe to a topic or group');
            return;
        }

        var $target = $(event.currentTarget);

        var topicRequiredBadges = $target.data('topic-required-badges');
        var missingBadges = dn.user.GetMissingBadges(topicRequiredBadges);

        // Check to see if the user has all the required badges
        if (missingBadges.length > 0)
        {
            dn.ShowBadgeModal(missingBadges, "to subscribe to this topic");
            return;
        }

        var topicId = $target.data('topic-id');
        var topicKey = $target.data('topic-key');
        var topicName = $target.data('topic-name');
        var topicIdOrKey = (topicId || topicKey);

        // can match multiple buttons on the same page, so the status of all of them can be updated at once
        // For example, on topic/group pages, the button appears on the right side, as well as in the dropdown menu.
        var $buttons = $('.btn-subscribe-topic[data-topic-id=' + topicId + '],.btn-subscribe-topic[data-topic-key=' + topicKey + ']');

        var subscribed = $target.hasClass("subscribed");
        var pending = $target.hasClass("pending");
        var rejected = $target.hasClass("rejected");

        var originalHtml = $target.html();
        var originalClasses = $target.attr("class");

        if ($target.hasClass("btn")) 
        {
            // Disable the button and show the status
            $buttons.attr('disabled', true).removeClass("subscribed not-subscribed pending");
        }

        topic.Lookup
        (
            {
                topicIdOrKey: topicIdOrKey, 
                showAjaxSpinner: true, 
                onSuccess: function(data) 
                {
                    if (data.AllowedCountries && data.AllowedCountries.length > 0 && !data.AllowedCountries.includes(dn.user.BusinessCountry))
                    {
                        // This topic/group is limited to certain countries, and theirs isn't one.
                        dn.ShowModal
                        (
                            {
                                title: 'Not Available in Your Country',
                                body: '<p>Subscriptions to <i>' + topicName + '</i> are not available in your country at this time.</p>'
                            }
                        );

                        // Set the button to it's original state
                        $buttons.attr('disabled', false).html(originalHtml).attr("class", originalClasses);
                    }
                    else
                    {
                        // Setup the external subscription settings just in case we do need to use them.
                        var externalSubscribeOptions = (data.ExternalSubscription && data.ExternalSubscription.Subscribe)
                        ? {
                            topic: data,
                            onSuccess: function(response) 
                            {
                                if (response.Action === topic.TopicAction.Completed)
                                {
                                    // Set the button to the `subscribed` state and re-enable it
                                    $buttons.attr('disabled', false).html('<i class="far fa-check"></i>Subscribed').addClass("subscribed").removeClass("not-subscribed pending");
                                }
                                else
                                {
                                    // Set the button to the `pending` state and re-enable it
                                    $buttons.attr('disabled', false).html('Pending').addClass("pending").removeClass("not-subscribed subscribed");
                                    $target.addClass("pending"); // so non-buttons that trigger this method will also have pending status set

                                    if (response.Message)
                                    {
                                        // Let's show them a custom message from the partner. 
                                        var $body = $('<div><p class="font-weight-bold">We received the following response from ' + data.ExternalSubscription.Partner.Name + ':</p><p class="dn-external-message">&nbsp;</p></div>');

                                        // We do it this way, using .text, to avoid XSS issues; we can't trust response.Message
                                        $body.find("p.dn-external-message").text(response.Message);

                                        dn.ShowModal
                                        (
                                            {
                                                title: "Subscription Request Pending",
                                                body: $body[0].outerHTML
                                            }
                                        );
                                    }
                                }
                            }, 

                            onError: function(xhr, textStatus, errorThrown) 
                            {
                                // Set the button to it's original state
                                $buttons.attr('disabled', false).html(originalHtml).attr("class", originalClasses);
                            }
                        }
                        : null;


                        if (pending)
                        {
                            // Pending, so give them an explanation as to what is going on here, and a chance to undo it.
                            if (externalSubscribeOptions)
                            {
                                // This is a closed group with an external subscription mechanism.
                                // Since they are pending, let's just see if they want to retry with the partner.
                                dn.ShowModal
                                (
                                    {
                                        title: 'Pending External Approval',
                                        body: '<p>Your request to subscribe to <i>' + topicName + '</i> was sent to ' + data.ExternalSubscription.Partner.Name + ' and is pending their approval. It could be that they are still working on your request, or they may be waiting on you to complete something for them.</p><p><b>You can choose to "Retry Subscription" below.</b></p>',
                                        buttonText: 'Retry Subscription',
                                        buttonClass: 'btn-primary',
                                        onButtonClick: function(event, $modal) 
                                        {
                                            topic.SubscribeExternally(externalSubscribeOptions);
                                        },
                                        onClose: function() 
                                        {
                                            // Set the button to it's original state
                                            $buttons.attr('disabled', false).html(originalHtml).attr("class", originalClasses);
                                        }
                                    }
                                );
                            }
                            else
                            {
                                // Regular pending request
                                dn.ShowModal
                                (
                                    {
                                        title: 'Subscription Pending',
                                        body: 'Your request to subscribe to <i>' + topicName + '</i> is pending approval by the managers of the group.',
                                        buttonText: 'Cancel Subscription Request',
                                        buttonClass: 'btn-danger',
                                        onButtonClick: function(event, $modal) 
                                        {
                                            // They want to cancel the subscription request, which we do via Unsubscribe
                                            topic.Unsubscribe
                                            (
                                                {
                                                    topicIdOrKey: topicIdOrKey, 

                                                    onSuccess: function(response) 
                                                    {
                                                        // Set the button to the `not-subscribed` state and re-enable it
                                                        $buttons.attr('disabled', false).html('Subscribe').addClass("not-subscribed").removeClass("subscribed pending");
                                                    }, 

                                                    onError: function(xhr, textStatus, errorThrown) 
                                                    {
                                                        // Set the button to it's original state
                                                        $buttons.attr('disabled', false).html(originalHtml).attr("class", originalClasses);

                                                        if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) {
                                                            dn.ShowModal({
                                                                title: 'Problem Unsubscribing',
                                                                body: dn.FormatApiError(xhr.responseJSON)
                                                            });
                                                        }
                                                    }
                                                }    
                                            );
                                        },
                                        onClose: function() 
                                        {
                                            // Set the button to it's original state
                                            $buttons.attr('disabled', false).html(originalHtml).attr("class", originalClasses);
                                        }
                                    }
                                );
                            }
                        }
                        else if (subscribed)
                        {
                            // Subscribed, so let's try to unsubscribe.
                            topic.Unsubscribe
                            (
                                {
                                    topicIdOrKey: topicIdOrKey, 

                                    onSuccess: function(response) 
                                    {
                                        // Set the button to the `not-subscribed` state and re-enable it
                                        $buttons.attr('disabled', false).html('Subscribe').addClass("not-subscribed").removeClass("subscribed pending");
                                    }, 

                                    onError: function(xhr, textStatus, errorThrown) 
                                    {
                                        // Set the button to it's original state
                                        $buttons.attr('disabled', false).html(originalHtml).attr("class", originalClasses);

                                        if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                                        {
                                            dn.ShowModal
                                            (
                                                {
                                                    title: 'Problem Unsubscribing',
                                                    body: dn.FormatApiError(xhr.responseJSON)
                                                }
                                            );
                                        }
                                    }
                                }
                            );
                        }
                        else if (rejected)
                        {
                            // Rejected, show them an error
                            $buttons.attr('disabled', false).html(originalHtml).attr("class", originalClasses);

                            dn.ShowModal
                            (
                                {
                                    title: 'Subscription Unavailable',
                                    body: 'You are not eligible to subscribe to this group at this time, either because a previous \
                                            subscription request was rejected, or you have been blocked from the group.<br/><br/>This \
                                            decision would have been made by the <a href="' + data.LinkDetailsRelative + '#managers">managers \
                                            of the group</a>, who have full control over who is permitted to subscribe.<br/><br/>If you \
                                            have any questions about this, please <a href="/contact">contact us</a>.'
                                }
                            );
                        }
                        else
                        {
                            // Not subscribed yet, so subscribe them
                            if (data.ExternalSubscription && data.ExternalSubscription.Subscribe)
                            {
                                // This is a closed group with an external subscription process.
                                // Prompt the user and make sure they are OK with us sending some
                                // of their data.
                                externalSubscribeOptions['$source'] = $target;
                                topic.SubscribeExternally(externalSubscribeOptions);
                            }
                            else
                            {
                                // Normal subscription process begins...
                                topic.Subscribe
                                (
                                    {
                                        topicIdOrKey: topicIdOrKey, 

                                        onSuccess: function(response) 
                                        {
                                            if (response.Action === topic.TopicAction.Completed)
                                            {
                                                // Set the button to the `subscribed` state and re-enable it
                                                $buttons.attr('disabled', false).html('<i class="far fa-check"></i>Subscribed').addClass("subscribed").removeClass("not-subscribed pending");
                                            }
                                            else
                                            {
                                                // Set the button to the `pending` state and re-enable it
                                                $buttons.attr('disabled', false).html('Pending').addClass("pending").removeClass("not-subscribed subscribed");
                                            }

                                            if (onSuccess)
                                            {
                                                onSuccess(response);
                                            }
                                        }, 

                                        onError: function(xhr, textStatus, errorThrown) 
                                        {
                                            // Set the button to it's original state
                                            $buttons.attr('disabled', false).html(originalHtml).attr("class", originalClasses);

                                            if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                                            {
                                                dn.ShowModal
                                                (
                                                    {
                                                        title: 'Problem Subscribing',
                                                        body: dn.FormatApiError(xhr.responseJSON)
                                                    }
                                                );
                                            }

                                            if (onError)
                                            {
                                                onError(xhr.responseJSON);
                                            }
                                        }
                                    }
                                );
                            }                                
                        }
                    }
                }, 

                // Problem getting info about the topic/group
                onError: function(xhr, textStatus, errorThrown) 
                {
                    $buttons.attr('disabled', false).html(originalHtml).attr("class", originalClasses);

                    if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                    {
                        // Couldn't locate the group for some reason, just show the error with no link
                        dn.ShowModal
                        (
                            {
                                title: 'Topic/Group Not Found',
                                body: 'We were unable to locate the topic or user group requested.<br/><br/>If this problem continues, please <a href="/contact">contact us</a>.'
                            }
                        );
                    }

                    if (onError)
                    {
                        onError(xhr.responseJSON);
                    }
                }
            }
        );
    };

    /**
     * @param {string}  opt.topicIdOrKey     - The TopicId or TopicKey to look up
     * @param {bool}    opt.showAjaxSpinner  - If true, we'll show a modal spinner if we have to make an ajax call (and hide it when done)
     * @param {func}    opt.onSuccess        - Once we have the Topic available, we send it to this callback.
     * @param {func}    opt.onError          - If we can't locate this topic's details for some reason, we'll call this callback.
     */
    topic.Lookup = function(opt) {

        if (!opt.topicIdOrKey) { return opt.onSuccess({}); } // nothing to lookup

        if (dn.constants.Topics.hasOwnProperty(opt.topicIdOrKey))
        {
            // A community topic, popular user group, or other cached user group
            opt.onSuccess(dn.constants.Topics[opt.topicIdOrKey]);
        }
        else 
        {
            // We don't have this topic locally, so look it up via the API
            if (opt.showAjaxSpinner)
            {
                dn.Spin(true);
            }

            $.get(topic.Urls.Lookup + "/" + encodeURIComponent(opt.topicIdOrKey))
            .done(function (data, textStatus, request) {
                dn.constants.Topics[data.TopicId] = data; // "cache" it for later
                if (opt.showAjaxSpinner)
                {
                    dn.Spin(false);
                }
                opt.onSuccess(data);
            })
            .fail(function (xhr, textStatus, errorThrown) {
                if (opt.showAjaxSpinner)
                {
                    dn.Spin(false);
                }
                if (opt.onError)
                {
                    opt.onError(errorThrown);
                }
            });
        }
    };

    /**
     * Get topic autosuggestions by passing a query string of a partial (or whole) topic name.
     * 
     * @param {string} opt.query - A whole or partial topic name. If null or empty, all topics and any subscribed groups will be returned.
     * @param {bool} opt.isManager - If true, only return topics and groups that this user is a manager of.
     * @param {function} opt.onSuccess - On success, we'll call this function with the returned data.
     * @param {function} opt.onError - On failure, we'll call this function with the error message.
     */
    topic.Query = function (opt) {

        $.postJSON(topic.Urls.Query, {
            Query: opt.query,
            IsManager: opt.isManager
        })
        .done(function (data, textStatus, request) 
        {
            if (opt.onSuccess)
            {
                opt.onSuccess(data);
            }
        })
        .fail(function (xhr, textStatus, errorThrown) {
            if (opt.onError)
            {
                opt.onError(errorThrown);
            }
        });
    };

    /**
     * Remove a manager from a group.
     * 
     * @param {string}  opt.topicIdOrKey     - The TopicId or TopicKey of the group being modified.
     * @param {string}  opt.userKey          - The UserKey of the user to make a manager of this group.
     * @param {func}    opt.onSuccess        - If we're able to successfully add the manager, we'll call this with the response.
     * @param {func}    opt.onError          - If we can't invite/approve the user for some reason, we'll call this with the jquery error info
     */
    topic.RemoveManager = function(opt) {

        $.deleteJSON("/api/v1/topic/" + opt.topicIdOrKey + "/manager", {
            UserKey: opt.userKey
        })
        .done(function (response) {

            dn.constants.Topics[response.Topic.TopicId] = response.Topic; // "cache" it for later

            if (opt.onSuccess)
            {
                opt.onSuccess(response);
            }
        })
        .fail(function (xhr, textStatus, errorThrown) {

            if (opt.onError)
            {
                opt.onError(xhr, textStatus, errorThrown);
            }
        });
    };

    /**
     * Set a new owner for a group.
     * 
     * @param {string}  opt.topicIdOrKey     - The TopicId or TopicKey of the group being modified.
     * @param {string}  opt.userKey          - The UserKey of the user to make the owner of this group.
     * @param {func}    opt.onSuccess        - If we're able to successfully set a new owner, we'll call this with the response.
     * @param {func}    opt.onError          - If we can't set the owner for some reason, we'll call this with the jquery error info
     */
    topic.SetOwner = function(opt) {

        $.postJSON("/api/v1/topic/" + opt.topicIdOrKey + "/owner", {
            UserKey: opt.userKey
        })
        .done(function (response) {

            dn.constants.Topics[response.Topic.TopicId] = response.Topic; // "cache" it for later

            if (opt.onSuccess)
            {
                opt.onSuccess(response);
            }
        })
        .fail(function (xhr, textStatus, errorThrown) {

            if (opt.onError)
            {
                opt.onError(xhr, textStatus, errorThrown);
            }
        });
    };

    /**
     * Attempt to subscribe the user to a user group, and then show them the results.
     * 
     * @param {string}  opt.topicIdOrKey     - The TopicId or TopicKey to subscribe to.
     * @param {string}  opt.message          - If set, will be shown to the group managers that are charged with approving people.
     * @param {func}    opt.onSuccess        - If we're able to successfully subscribe (or queue subscription), we'll call this with the response.
     * @param {func}    opt.onError          - If we can't subscribe the user for some reason, we'll call this with the jquery error info
     */
    topic.Subscribe = function(opt) 
    {
        $.postJSON
        (
            "/api/v1/topic/" + opt.topicIdOrKey + "/subscription", 
            Object.assign
            (
                {
                    Message: opt.message
                }, 
                opt.partnerData
            )
        )
        .done(function (response) 
        {
            dn.constants.Topics[response.Topic.TopicId] = response.Topic; // "cache" it for later

            if (response.Action === topic.TopicAction.Completed)
            {
                // Add the TopicId to the dn.user.TopicSubscriptions array
                if ($.isArray(dn.user.TopicSubscriptions))
                {
                    dn.user.TopicSubscriptions.push(response.Topic.TopicId);
                }
                else
                {
                    dn.user.TopicSubscriptions = [response.Topic.TopicId];
                }
            }
            else
            {
                // Add the TopicId to the dn.user.TopicSubscriptionsPending array
                if ($.isArray(dn.user.TopicSubscriptionsPending))
                {
                    dn.user.TopicSubscriptionsPending.push(response.Topic.TopicId);
                }
                else
                {
                    dn.user.TopicSubscriptionsPending = [response.Topic.TopicId];
                }
            }

            if (opt.onSuccess)
            {
                opt.onSuccess(response);
            }
        })
        .fail(function (xhr, textStatus, errorThrown) {

            if (opt.onError)
            {
                opt.onError(xhr, textStatus, errorThrown);
            }
        });
    };


    /**
     * Show the modal to confirm with the user their group subscription request, since
     * it requires an external subscription request. We'll confirm that they are comfortable
     * sharing their data with the partner at the given domain, and allowing them to confirm
     * which pieces of their data they wish to allow to be sent. 
     * 
     * The partner can also define a prompt for the user if they want to retrieve an additional
     * piece of information from them. 
     * 
     * @param {object} topic   - The topic/group they are trying to subscribe to.
     */
    topic.SubscribeExternally = function(opt) 
    {
        var title = "Confirm Subscription Request";
        var exSub = opt.topic.ExternalSubscription;

        $('#' + opt.topic.SubscribeExternallyId).remove();  // remove if it already exists

        var checkboxes = [];
        exSub.Subscribe.RequestedFields.forEach
        (
            // Looping over each field of data this partner would like sent to them. We'll turn
            // these into checkboxes, letting the user decide whether or not they want to send it.
            function(field, idx)
            {
                checkboxes.push('<div class="custom-control custom-checkbox"><input type="checkbox" class="custom-control-input ' + opt.topic.SubscribeExternallyId + '-checkbox" id="' + opt.topic.SubscribeExternallyId + '-checkbox-' + field + '" data-field="' + field + '" value="true" checked><label class="custom-control-label" for="' + opt.topic.SubscribeExternallyId + '-checkbox-' + field + '">' + field.replace(dn.constants.RegEx.CaseDivisions, "$1 $2") + '</label></div>');
            }
        );

        $("body").append($('<div class="modal" tabindex="-1" role="dialog" style="display: none" id="' + opt.topic.SubscribeExternallyId + '">\
            <div class="modal-dialog" role="document">\
                <div class="modal-content">\
                    <div class="modal-header">\
                        <h5 class="modal-title"><b>' + title + '</b></h5>\
                        <button type="button" class="close ' + opt.topic.SubscribeExternallyId + '-close" data-dismiss="modal" aria-label="Close">\
                        <span aria-hidden="true">&times;</span>\
                        </button>\
                    </div>\
                    <div class="modal-body">\
                        <p><b>' + opt.topic.Name + '</b> subscriptions require external approval by the owner of the group, ' + exSub.Partner.Name + '. If you continue, we\'ll send your request to <b>' + exSub.Subscribe.Domain + '</b> (<a href="' + exSub.Partner.PrivacyPolicy + '" target="' + dn.constants.LinkTargetNewWindow + '">privacy policy</a>).</p>' +

                        '<div class="alert alert-danger" style="display: none" id="' + opt.topic.SubscribeExternallyId + '-error" role="alert"></div>' + 

                        (
                            checkboxes.length > 0
                            ? 
                            (
                                '<p>You can choose what information we send:</p>' + checkboxes.join("")
                            )
                            : ""
                        ) 

                        +

                        (
                            // Show optional prompt for additional information from the partner, if provided
                            (exSub.Subscribe.Prompt)
                            ? 
                            (
                                '<label for="' + opt.topic.SubscribeExternallyId + '-amount" class="dn-form-label mt-2">' + exSub.Subscribe.Prompt + '</label>\
                                <div class="input-group mb-3">\
                                    <input type="text" id="' + opt.topic.SubscribeExternallyId + '-prompt" value="" class="form-control col-12" aria-label="Answer to the question above" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"> \
                                </div>'
                            )
                            : ''
                        )

                        +

                        ((checkboxes.length > 0 || exSub.Subscribe.Prompt) ? '<p class="mt-3"><b>Note:</b> ' + exSub.Partner.Name + ' may require some of the above information to approve your subscription, and if you have an existing account with them, it\'s best if your email address (' + dn.user.Email + ') matches on both services <i>before</i> subscribing. <a href="/settings">You can update your email address here.</a></p>' : '') 

                        +

                        '<p id="closing-modal"></p>\
                    </div>\
                    <div class="modal-footer">\
                        <button type="button" class="btn btn-secondary ' + opt.topic.SubscribeExternallyId + '-close" id="' + opt.topic.SubscribeExternallyId + '-cancel" data-dismiss="modal">Cancel</button>\
                        <button type="button" class="btn btn-primary" id="' + opt.topic.SubscribeExternallyId + '-button">Send Request</button>\
                    </div>\
                </div>\
            </div>\
        </div>'));

        // stop any spinners before showing our new one
        dn.Spin(false);

        // remember the modals that were already open before us, so we can show them when done. 
        var openModals = $('.modal.show');
        openModals.modal('hide');

        var id = '#' + opt.topic.SubscribeExternallyId;
        var $modal = $(id).modal();

        // Close button clicked
        $('.' + opt.topic.SubscribeExternallyId + '-close').click
        (
            function(event) 
            {
                openModals.modal('show'); // re-show modals that were open when we first appeared
                if (opt.onClose)
                {
                    opt.onClose();
                }
            }
        );

        // the "Send Request" button was clicked
        $(id + '-button').click
        (
            function () 
            {
                // Clear any previous errors for now
                $(id + '-error').hide();

                // Disable the button while we process the request, show our spinner
                $(id + '-button').prop("disabled", true);
                dn.Spin(true);

                topic.Subscribe
                (
                    {
                        topicIdOrKey: opt.topic.TopicId, 
                        partnerData: 
                        {
                            ApprovedFields: $("input." + opt.topic.SubscribeExternallyId + "-checkbox:checkbox:checked").map(function() { return $(this).data("field"); }).get(),
                            IsExternalSubscriptionRequest: true,
                            PromptResponse: ($('#' + opt.topic.SubscribeExternallyId + '-prompt').val() || null)
                        },

                        onSuccess: function(response) 
                        {
                            // Stop the progress spinner and close the confirmation dialog
                            $(id + '-button').prop("disabled", false);
                            dn.Spin(false);
                            $modal.modal('hide');

                            if (opt.onSuccess)
                            {
                                opt.onSuccess(response);
                            }
                        }, 

                        onError: function(xhr, textStatus, errorThrown) 
                        {
                            // Stop the progress spinner and close the confirmation dialog
                            $(id + '-button').prop("disabled", false);
                            dn.Spin(false);

                            if (!dn.IsErrorHandledAutomatically(null, xhr, null, errorThrown)) 
                            {
                                // The initial request for the message details failed, tell the user
                                $(id + '-error').text(dn.FormatApiError(xhr.responseJSON)).show();
                            }
                        }
                    }
                );
            }
        );

        $(id).modal('show');
    };

    /**
     * Uninvite a user from a group, which removes/bans them from the group if already subscribed, or rejects
     * their subscription request if requested.
     * 
     * @param {string}  opt.topicIdOrKey     - The TopicId or TopicKey to uninvite from.
     * @param {string}  opt.userKey          - The UserKey of the user to uninvite/ban.
     * @param {string}  opt.message          - If set, will be sent to the user being invited/approved.
     * @param {func}    opt.onSuccess        - If we're able to successfully invite (or queue invitation), we'll call this with the response.
     * @param {func}    opt.onError          - If we can't invite/approve the user for some reason, we'll call this with the jquery error info
     */
    topic.Uninvite = function(opt) 
    {
        $.deleteJSON("/api/v1/topic/" + opt.topicIdOrKey + "/invitation", {
            UserKey: opt.userKey,
            Message: opt.message
        })
        .done(function (response) {

            dn.constants.Topics[response.Topic.TopicId] = response.Topic; // "cache" it for later

            if (opt.onSuccess)
            {
                opt.onSuccess(response);
            }
        })
        .fail(function (xhr, textStatus, errorThrown) {

            if (opt.onError)
            {
                opt.onError(xhr, textStatus, errorThrown);
            }
        });
    };

    /**
     * Attempt to unsubscribe the user from a user group, and then show them the results.
     * 
     * @param {string}  opt.topicIdOrKey     - The TopicId or TopicKey to unsubscribe from.
     * @param {string}  opt.userKey          - (Optional) If a manager is calling this on behalf of another user subscribed to their 
     *                                         group (to remove them), pass the user's UserKey.
     * @param {string}  opt.message          - (Optional) If set, and a manager is calling this on behalf of another user, this message
     *                                         will be sent to the user being removed.
     * @param {func}    opt.onSuccess        - If we're able to successfully subscribe (or queue subscription), we'll call this with the response.
     * @param {func}    opt.onError          - If we can't subscribe the user for some reason, we'll call this with the jquery error info
     */
    topic.Unsubscribe = function(opt) 
    {
        $.deleteJSON("/api/v1/topic/" + opt.topicIdOrKey + "/subscription", 
        {
            UserKey: opt.userKey,
            Message: opt.message
        })
        .done(function (response) {

            dn.constants.Topics[response.Topic.TopicId] = response.Topic; // "cache" it for later

            if ($.isArray(dn.user.TopicSubscriptions))
            {
                // Remove the TopicId from the dn.user.TopicSubscriptions array
                dn.user.TopicSubscriptions = dn.user.TopicSubscriptions.filter(function(topicId) {
                    return (topicId !== response.Topic.TopicId);
                });
            }

            if ($.isArray(dn.user.TopicSubscriptionsPending))
            {
                // Remove the TopicId from the dn.user.TopicSubscriptionsPending array, if it's there
                dn.user.TopicSubscriptionsPending = dn.user.TopicSubscriptionsPending.filter(function(topicId) {
                    return (topicId !== response.Topic.TopicId);
                });
            }

            if (opt.onSuccess)
            {
                opt.onSuccess(response);
            }
        })
        .fail(function (xhr, textStatus, errorThrown) {

            if (opt.onError)
            {
                opt.onError(xhr, textStatus, errorThrown);
            }
        });
    };

    $(document).ready(function ($)
    {
        // Wire up any subscription buttons on the page to our handler for subscribe/unsubscribe.
        $('.btn-subscribe-topic').click(dn.topic.HandleSubscribeClick);
    });

}(window.dn.topic = window.dn.topic || {}, jQuery));
